import {
	PagedMultiSelectField,
	PagedSingleSelectField,
	SelectDefaultOption,
	laravelServiceSelectFetchConfig,
	withOptionsEndpoint,
} from "@dgs/core";
import { FC } from "react";
import styled from "styled-components";
import { TagOptionResource } from "../types/tag";

const service = withOptionsEndpoint<TagOptionResource>(["tags"]);
const fetchConfig = laravelServiceSelectFetchConfig(service);

interface Props {
	name: string;
	label: string;
	required?: boolean;
}

const CategoryText = styled.small`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
	margin-left: 0.25rem;
`;

export const TagMultiSelectField: FC<Props> = (props) => {
	return (
		<PagedMultiSelectField
			{...props}
			fetchConfig={fetchConfig}
			renderOption={(tag, isSelected, isHovered) => (
				<SelectDefaultOption $isSelected={isSelected} $isHovered={isHovered}>
					{tag.name}
					{tag.category?.name && <CategoryText>({tag.category.name})</CategoryText>}
				</SelectDefaultOption>
			)}
		/>
	);
};

export const TagSingleSelectField: FC<Props> = (props) => {
	return (
		<PagedSingleSelectField
			{...props}
			fetchConfig={fetchConfig}
			renderOption={(tag, isSelected, isHovered) => (
				<SelectDefaultOption $isSelected={isSelected} $isHovered={isHovered}>
					{tag.name}
					{tag.category?.name && <CategoryText>({tag.category.name})</CategoryText>}
				</SelectDefaultOption>
			)}
		/>
	);
};
